import { useState } from 'react';
import { MainAdminLayout } from 'admin/layout/MainAdminLayout';
import { MainTable } from 'admin/components/Table';
import { PackageViewModal } from 'admin/components/Packages/PackageViewModal';
import { PACKAGE_DATA, PACKAGES_HEADER } from 'admin/TableDatas/mockDatas';
import { ACTIVE_TABS, SHOW_CONTENT_NUMBERS } from 'admin/utils/contants';
import { HotOfferTopBlock } from 'admin/components/HotOffers/hotOfferTopBlock';

export const HotOffers = () => {
  const [selected, setSelected] = useState(SHOW_CONTENT_NUMBERS[0].value);
  const [packageData, setPackageData] = useState(PACKAGE_DATA);
  const [selectedItems, setSelectedItems] = useState(null);
  const [isViewModal, setIsViewModal] = useState(true);
  const [viewModalData, setViewModalData] = useState([]);

  const handleViewModal = (rowData) => {
    setIsViewModal((prev) => !prev);
    setViewModalData(rowData);
  };

  return (
    <MainAdminLayout>
      {isViewModal ? (
        <>
          <HotOfferTopBlock
            setSelected={setSelected}
            selected={selected}
            _data={packageData}
            setData={setPackageData}
            selectedItems={selectedItems}
          />

          <MainTable
            headerData={PACKAGES_HEADER}
            _data={packageData}
            setDelete={setPackageData}
            selected={selected}
            activeTab={ACTIVE_TABS.HOT_OFFERS}
            setSelectedItems={setSelectedItems}
            selectedItems={selectedItems}
            handleViewModal={handleViewModal}
            setViewModalData={setViewModalData}
          />
        </>
      ) : (
        <PackageViewModal
          viewModalData={viewModalData}
          handleViewModal={handleViewModal}
        />
      )}
    </MainAdminLayout>
  );
};
